export default {"src":"/_next/static/media/awareness-icon.62ece493.svg","height":500,"width":500};